import React, { FC } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import colors from "../constants/colors";

interface ITextProps {
  children: React.ReactNode;
  bold?: boolean;
  italic?: boolean;
  align?: "left" | "center" | "right" | "inherit" | "justify";
  gutterBottom?: boolean;
  size?: "large" | "regular" | "small";
  color?: "primary" | "secondary" | "error";
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2"
    | "caption"
    | "button"
    | "overline"
    | "srOnly"
    | "inherit";
  className?: string;
}

export const Text: FC<ITextProps> = ({
  children,
  bold = false,
  italic = false,
  size = "regular",
  color = "primary",
  className = "",
  ...rest
}) => {
  const classes = styles({ bold, color, size, italic });
  return (
    <Typography {...rest} className={`${classes.text} ${className}`}>
      {children}
    </Typography>
  );
};

const styles = makeStyles(({ typography }) => ({
  text: ({ bold, color, size, italic }: any) => ({
    color:
      color === "secondary"
        ? colors.textSecondary
        : color === "error"
        ? colors.errorText
        : colors.secondary,
    fontFamily: typography.fontFamily,
    fontStyle: italic ? "italic" : "normal",
    fontWeight: bold ? "bold" : "normal",
    fontSize: size === "small" ? "12px" : size === "large" ? "22px" : "18px",
  }),
}));
